import { useRequest } from 'ahooks';
import { queryConfigByKey } from 'services/api/admin';

// AE 下发配置分为 org 和 store 级别
// 该接口为 org 级别的下发条数限制
// PD: https://leyan.yuque.com/czpqnb/pd/xzfxk7bafcegxp3g
export const useAEAIServiceConfig = () => {
  const { data, loading } = useRequest(() => {
    return queryConfigByKey('AI_SERVICE_BUYER_LIMIT');
  });

  return {
    configType: data !== 0 ? 'org' : 'store',
    loading,
  };
};
